import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faHeading } from "@fortawesome/pro-regular-svg-icons";
import Button from "./ToolbarButton";
import { ToolbarWrap, Separator } from "./ToolbarUtils";
import { useEditorContext } from "./EditorContext";

interface HeadingItem {
  isActive: boolean;
  canExec: boolean;
  command: () => void;
}

interface HeadlineToolbarProps {
  headings: {
    heading1: HeadingItem;
    heading2: HeadingItem;
    heading3: HeadingItem;
    heading4: HeadingItem;
    heading5: HeadingItem;
  };
  onBack: () => void;
}

export default function HeadlineToolbar({
  headings,
  onBack,
}: HeadlineToolbarProps) {
  const { readOnly } = useEditorContext();
  const headingLevels = Object.keys(headings)
    .map((key) => parseInt(key.replace("heading", "")))
    .sort((a, b) => a - b);

  const renderHeadingButton = (level: number) => {
    const headingKey = `heading${level}` as keyof typeof headings;
    const heading = headings[headingKey];
    const markdownShortcut = "#".repeat(level);

    return (
      <Button
        key={`heading-${level}`}
        pressed={heading.isActive}
        disabled={readOnly || !heading.canExec}
        onClick={heading.command}
        tooltip={I18n.t("js.composer.editor.buttons.headline", {
          level: level,
          markdown_shortcut: markdownShortcut,
        })}
      >
        <span className="fa-layers fa-fw">
          <FontAwesomeIcon
            icon={faHeading}
            transform="shrink-2 left-2"
            size={window.isApp ? "xl" : undefined}
          />
          <span
            className="fa-layers-text"
            data-fa-transform={`shrink-5 ${
              window.isApp ? "down-8 right-10" : "down-4 right-7"
            }`}
          >
            {level}
          </span>
        </span>
      </Button>
    );
  };

  return (
    <ToolbarWrap>
      <Button
        onClick={onBack}
        tooltip={I18n.t("js.composer.editor.buttons.no_headline")}
        disabled={readOnly}
      >
        <FontAwesomeIcon
          icon={faChevronLeft}
          size={window.isApp ? "xl" : undefined}
        />
      </Button>

      <Separator />

      {headingLevels.map(renderHeadingButton)}
    </ToolbarWrap>
  );
}
